/**
 * OwalSearchMatchCondition.js
 *
 * @description Contains an enum for conditions which describe a successful search.
 */

/**
 * The condition under which a predicate returns true.
 */
export const OwalSearchMatchCondition = {
  BEGINS_WITH: 1,
  END_WITH: 2,
  INCLUDES: 3,
  EQUALS: 4,
  GREATER_THAN: 5,
  LESS_THAN: 6,
  GREATER_THAN_OR_EQUAL_TO: 7,
  LESS_THAN_OR_EQUAL_TO: 8,
  implementation: {
    1: function (a, b) {
      if (a.startsWith !== 'function') {
        console.warn(`OwalSearchMatchCondition: LHS doesn't support includes. Treating as startsWith. (LHS: ${a} (${typeof a}, RHS: ${b}, ${typeof b}))`)
        return false
      }
      return a.startsWith(b)
    },
    2: function (a, b) {
      if (a.endsWith !== 'function') {
        console.warn(`OwalSearchMatchCondition: LHS doesn't support includes. Treating as endsWith. (LHS: ${a} (${typeof a}, RHS: ${b}, ${typeof b}))`)
        return false
      }
      return a.endsWith(b)
    },
    3: function (a, b) {
      if (!a.includes || typeof a.includes !== 'function') {
        console.warn(`OwalSearchMatchCondition: LHS doesn't support includes. Treating as non-match. (LHS: ${a} (${typeof a}, RHS: ${b}, ${typeof b}))`)
        return false
      }
      const includes = a.includes(b)
      // console.debug('includes', includes)
      return includes
    },
    4: function (a, b) {
      return a === b
    },
    5: function (a, b) {
      return a > b
    },
    6: function (a, b) {
      return a < b
    },
    7: function (a, b) {
      return a >= b
    },
    8: function (a, b) {
      return a <= b
    },
  },
  description: {
    1: 'begins with',
    2: 'ends with',
    3: 'includes',
    4: '===',
    5: '>',
    6: '<',
    7: '>=',
    8: '<=',
  },
}
